import { render, staticRenderFns } from "./Workflow.vue?vue&type=template&id=5c1a2c62&scoped=true"
import script from "./Workflow.vue?vue&type=script&lang=js"
export * from "./Workflow.vue?vue&type=script&lang=js"
import style0 from "./Workflow.vue?vue&type=style&index=0&id=5c1a2c62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1a2c62",
  null
  
)

export default component.exports